var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.loading
        ? _c("div", { staticClass: "app-loading" }, [_c("sm-loader")], 1)
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading ? _c("router-view") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }